import React from "react";
import { autobind } from "lib/decorators";
import _ from "lodash";
import { observer } from "mobx-react";
import NavigationTreeStore from "./Store";
import { L, TranslationMixin } from "lib/translation";

const portalSite = window.location.pathname.split("/")[1];
const appledevice =
  luvit && luvit.ua
    ? luvit.ua.indexOf("applewebkit", 0) > 0 &&
      (luvit.ua.indexOf("iphone", 0) > 0 || luvit.ua.indexOf("ipad", 0) > 0)
    : false;
const FILE_PDF = 18;
const aAppledeviceBlankTarget = (typeID) => [FILE_PDF].includes(typeID);

@TranslationMixin({ contexts: ["NavigationTree"] })
class ListItem extends React.Component {
  render() {
    let { item, expanded, active, type } = this.props;
    let expandClass = expanded ? "icon-collapse" : "icon-expand";
    let itemClass = active ? "active" : "";
    let childNodes = item.childNodes && item.childNodes.length > 0;
    let navTreeId = item.navTreeID;
    let tooltip = item.hint ? item.hint : item.title;

    if (item.typeID == "0") navTreeId = "0";

    // let utcDate = moment.utc(Date.now());
    let utcDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
      new Date().getUTCHours(),
      new Date().getUTCMinutes(),
      new Date().getUTCSeconds(),
    );
    let localPublishStart = moment.utc(item.publishStart).toDate();
    let localPublishStop = moment.utc(item.publishStop).toDate();

    if (!item.enabled) {
      itemClass += " italic";
      tooltip += " (" + this.props.L("NavigationTree", "nodenotvisible") + ")";
    } else if (
      item.publishStart &&
      moment(item.publishStart).isAfter(utcDate)
    ) {
      itemClass += " italic";
      tooltip +=
        " (" +
        this.props.L("NavigationTree", "publishStart") +
        " " +
        moment(localPublishStart).format("YYYY-MM-DD HH:mm") +
        ")";
    } else if (
      item.publishStop &&
      moment(item.publishStop).isBefore(utcDate) &&
      item.publishStopEnabled
    ) {
      itemClass += " italic";
      tooltip +=
        " (" +
        this.props.L("NavigationTree", "publishStop") +
        " " +
        moment(localPublishStop).format("YYYY-MM-DD HH:mm") +
        ")";
    }

    let showNode = true;

    //Don't show hembollen if user is not isAdmin
    if (navTreeId == "0") showNode = false;

    let icon = item.pathToImage;
    let target =
      appledevice && aAppledeviceBlankTarget(item.typeID)
        ? "_blank"
        : "iFrameMainContent";

    if (item.studentPublish && item.typeID == "1") {
      icon = "navtree-icon-studentfolderclosed";
    }

    let aDoc = (
      <a
        target={target}
        href={
          "/" +
          portalSite +
          "/education/viewdoc.aspx?navtreeid=" +
          navTreeId +
          "&typeid=" +
          item.typeID
        }
        onClick={(e) => this.props.onClick(e)}
      >
        <div className="flex align-top break-not-word ">
          <div className={icon} />
          <span className={item.typeID == "1" ? "bold" : ""}>{item.title}</span>
        </div>
      </a>
    );

    if (
      (!NavigationTreeStore.isAdmin &&
        item.typeID == "1" &&
        !item.studentPublish) ||
      (NavigationTreeStore.studentView &&
        !item.studentPublish &&
        item.typeID == "1")
    ) {
      aDoc = (
        <div
          id={item.navTreeID}
          onClick={this.props.onExpandToggle}
          className="navtree-item"
        >
          <div className="flex align-top break-not-word padding-r-40 ">
            <div className={icon} />
            <span className={item.typeID == "1" ? "bold" : ""}>
              {item.title}
            </span>
          </div>
        </div>
      );
    }

    return (
      showNode && (
        <li
          id={item.navTreeID}
          className={itemClass}
          data-type={type}
          title={tooltip}
        >
          {aDoc}
          {childNodes && (
            <div className={expandClass} onClick={this.props.onExpandToggle} />
          )}
          {childNodes && (
            <List
              list={item.childNodes}
              expanded={expanded}
              onClick={this.props.onClick}
              onExpandToggle={this.props.onExpandToggle}
            />
          )}
        </li>
      )
    );
  }
}

class List extends React.Component {
  render() {
    let { list, expanded, root } = this.props;
    let menuClassname =
      !root && !expanded
        ? "menu-expandlist-content contracted"
        : "menu-expandlist-content ";
    return (
      <ul
        {...(!root && { className: menuClassname })}
        {...(root && { className: "navtree" })}
        aria-hidden={expanded}
        id={root ? "navtree" : ""}
      >
        {list.map((li) => (
          <ListItem
            key={li.navTreeID}
            item={li}
            type={li.typeID}
            expanded={li.expanded}
            active={li.active}
            onClick={this.props.onClick}
            onExpandToggle={this.props.onExpandToggle}
          />
        ))}
      </ul>
    );
  }
}

@observer
export default class NavTree extends React.Component {
  async componentWillMount() {
    await NavigationTreeStore.reload();

    this.setState({ ready: true });
  }

  onToggleVisible(e) {
    NavigationTreeStore.toggleNode(e);
  }

  treeNodeClicked(e) {
    NavigationTreeStore.setSelectedNode(e.currentTarget.parentElement.id);

    //Function in main.aspx
    TreeNodeClicked(e.currentTarget, e.currentTarget.parentElement.id);
  }

  buildNestedHierarchy(nodes) {
    if (!nodes || !nodes.length) return nodes || [];

    let tempNodes = nodes.slice();
    //let tempNodes = $.extend(true, [], nodes);

    let nodeObjs = _.zipObject(
      _.map(tempNodes, (n) => n.navTreeID),
      tempNodes,
    );
    let rootNodes = [];

    // Reset to avoid duplicates, solve som other way?
    _.each(tempNodes, (n) => {
      n.childNodes = [];
    });

    _.each(tempNodes, (n) => {
      let parent = nodeObjs[n.parent];
      if (!parent) {
        n.childNodes = [];
        rootNodes.push(n);
      } else {
        if (!parent.childNodes) parent.childNodes = [];
        parent.childNodes.push(n);
      }
    });

    return rootNodes;
  }

  render() {
    if (!this.state || !this.state.ready) return <div />;

    return (
      <List
        list={this.buildNestedHierarchy(NavigationTreeStore.nodes)}
        root={true}
        onClick={(e) => this.treeNodeClicked(e)}
        onExpandToggle={(e) => this.onToggleVisible(e)}
      />
    );
  }
}
